// 吃瓜17 - 首页内容数据
export interface NavLink {
  id: string;
  label: string;
}

export const navLinks: NavLink[] = [
  { id: "rank", label: "热榜排行" },
  { id: "focus", label: "焦点专区" },
  { id: "buzz", label: "大瓜现场" },
  { id: "deep", label: "深度讨论" },
  { id: "about", label: "关于我们" },
];

export const tickerItems: string[] = [
  "全网实时抓取 · 每 5 分钟刷新一次热度指数",
  "今日新增热议话题 128 个，讨论量突破 460 万",
  "热点聚焦：暑期档电影口碑两极分化讨论持续升温",
  "多档综艺开启新一季阵容官宣，话题阅读量激增",
  "体育赛事黑马爆冷晋级，热搜词条一度冲上榜首",
];

export interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  trend: "up" | "down" | "flat";
  desc: string;
}

export const rankList: RankItem[] = [
  { rank: 1, title: "暑期档院线口碑之争，谁才是真正的黑马", tag: "娱乐影视", heat: 98, trend: "up", desc: "多部新片同日上映，评分与票房倒挂引发全网热议。" },
  { rank: 2, title: "当红综艺官宣新一季阵容，网友反应两极化", tag: "娱乐综艺", heat: 94, trend: "up", desc: "常驻名单公布不到一小时，相关话题已冲上热搜前三。" },
  { rank: 3, title: "电商大促规则太绕，年轻人的消费观悄悄变了", tag: "生活财经", heat: 89, trend: "up", desc: "越来越多人开始算账下单，拒绝为复杂玩法买单。" },
  { rank: 4, title: "一位美食主播的摆摊日常，为何治愈了千万网友", tag: "社会民生", heat: 86, trend: "flat", desc: "朴素记录意外走红，评论区成了打工人的树洞。" },
  { rank: 5, title: "城市马拉松周末开跑，'显眼包'穿搭抢镜热搜", tag: "体育竞技", heat: 82, trend: "up", desc: "赛场上各种创意跑者走红，赛事热度与话题齐飞。" },
  { rank: 6, title: "科技发布会新品扎堆，网友最期待的功能是它", tag: "科技数码", heat: 78, trend: "down", desc: "多家厂商同周开发布会，续航与生态成讨论焦点。" },
  { rank: 7, title: "老牌国货借社交平台翻红，情怀能否接住流量", tag: "商业财经", heat: 73, trend: "up", desc: "直播间人气暴涨，但品控与服务被放上放大镜。" },
  { rank: 8, title: "动物园顶流动物们的日常，凭表情包圈粉无数", tag: "生活百态", heat: 69, trend: "flat", desc: "萌宠营业视频刷屏，官号涨粉速度让运营都惊讶。" },
  { rank: 9, title: "反套路短剧成新宠，观众为何越看越上头", tag: "内容行业", heat: 64, trend: "up", desc: "节奏快、爽点密，微短剧热度带动演员走红。" },
  { rank: 10, title: "开学季宿舍好物测评，资深学姐盘点避坑指南", tag: "校园生活", heat: 58, trend: "down", desc: "开学装备清单刷屏，真实使用感受比广告更有说服力。" },
];

export interface FocusItem {
  name: string;
  count: string;
  icon: string;
  desc: string;
}

export const focusTabs: FocusItem[] = [
  { name: "娱乐影视", count: "今日 326 条", icon: "ri-film-line", desc: "影视热映、艺人动态、片场轶事、口碑走势一网打尽。" },
  { name: "社会民生", count: "今日 214 条", icon: "ri-community-line", desc: "生活百态、温暖故事、公共话题，理性围观不站队。" },
  { name: "科技财经", count: "今日 187 条", icon: "ri-robot-2-line", desc: "新品发布、行业动态、消费趋势，看懂热点背后的门道。" },
  { name: "体育竞技", count: "今日 98 条", icon: "ri-trophy-line", desc: "赛事集锦、名场面、体坛热点，为热爱欢呼也看门道。" },
  { name: "网络热议", count: "今日 152 条", icon: "ri-chat-3-line", desc: "热搜词条、梗图名场面、网络现象，一起蹲后续。" },
];

export interface FocusCard {
  tag: string;
  title: string;
  heat: string;
  time: string;
}

export const focusCards: Record<string, FocusCard[]> = {
  娱乐影视: [
    { tag: "院线", title: "暑期档口碑榜出炉，这部小成本喜剧意外登顶", heat: "98.2万", time: "12 分钟前" },
    { tag: "剧集", title: "年度大剧收官夜，全员演技在线被赞'教科书级'", heat: "86.4万", time: "38 分钟前" },
    { tag: "艺人", title: "实力派演员回应番位争议：角色本身最重要", heat: "63.1万", time: "1 小时前" },
    { tag: "综艺", title: "选秀类节目重启，导师阵容引发老粉集体怀旧", heat: "54.9万", time: "2 小时前" },
  ],
  社会民生: [
    { tag: "暖闻", title: "店主为考研学子留灯三年，网友：被善意戳到", heat: "92.7万", time: "8 分钟前" },
    { tag: "现象", title: "年轻人开始流行'电子榨菜'，吃饭必配解说", heat: "71.3万", time: "26 分钟前" },
    { tag: "普法", title: "民法典科普帖走红：原来这些条款和日常相关", heat: "45.8万", time: "1 小时前" },
    { tag: "调查", title: "城市深夜食堂调查：烟火气里藏着百种人生", heat: "39.6万", time: "3 小时前" },
  ],
  科技财经: [
    { tag: "数码", title: "新旗舰续航实测出炉，快充与电池容量成胜负手", heat: "84.2万", time: "15 分钟前" },
    { tag: "AI", title: "AI 绘图进化到新阶段，创意工作者如何应对", heat: "77.5万", time: "33 分钟前" },
    { tag: "消费", title: "一杯奶茶的定价逻辑，被拆解后网友直呼长见识", heat: "62.0万", time: "1 小时前" },
    { tag: "理财", title: "稳健理财走热，低风险产品重获年轻人青睐", heat: "48.9万", time: "2 小时前" },
  ],
  体育竞技: [
    { tag: "赛事", title: "马拉松周末开跑，破纪录选手成全场焦点", heat: "79.3万", time: "20 分钟前" },
    { tag: "名场", title: "决胜局逆风翻盘，现场解说激动到破音", heat: "73.8万", time: "40 分钟前" },
    { tag: "电竞", title: "电竞大赛冠军花落谁家，赛前数据前瞻", heat: "66.2万", time: "1 小时前" },
    { tag: "趣闻", title: "业余选手花式参赛装备，成场边最大看点", heat: "41.5万", time: "3 小时前" },
  ],
  网络热议: [
    { tag: "热搜", title: "新梗词条空降热搜榜，官方账号也下场玩梗", heat: "88.6万", time: "5 分钟前" },
    { tag: "名场面", title: "直播间即兴发挥名场面，切片视频全网刷屏", heat: "76.9万", time: "29 分钟前" },
    { tag: "现象", title: "年轻人晒出'治愈系角落'，仪式感拉满", heat: "58.4万", time: "1 小时前" },
    { tag: "后续", title: "上周爆火视频迎来反转，当事人发长文回应", heat: "51.2万", time: "2 小时前" },
  ],
};

export interface BuzzItem {
  img: string;
  tag: string;
  title: string;
  excerpt: string;
  comments: string;
  likes: string;
  time: string;
}

export const buzzList: BuzzItem[] = [
  {
    img: "https://readdy.ai/api/search-image?query=Stylized%20editorial%203D%20illustration%20of%20a%20large%20glossy%20watermelon%20slice%20with%20coral%20red%20flesh%20and%20dark%20green%20rind%20floating%20over%20a%20warm%20cream%20canvas%20with%20soft%20melon%20green%20orbs%20and%20subtle%20paper%20grain%2C%20modern%20magazine%20cover%20art%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=760&height=520&seq=buzz-01&orientation=landscape",
    tag: "口碑之战",
    title: "暑期档口碑与票房倒挂，黑马导演谈创作初心",
    excerpt: "评分一路走高票房却显平淡，评论区吵翻天。主创回应：比起数字，更想拍出让人记住的故事。",
    comments: "12.8万",
    likes: "9.6万",
    time: "32 分钟前",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cute%20isometric%203D%20illustration%20of%20a%20megaphone%20and%20floating%20chat%20notification%20bubbles%20in%20watermelon%20red%20and%20melon%20green%20on%20cream%20background%2C%20warm%20editorial%20style%2C%20soft%20shadows%2C%20playful%20modern%20vector%20art%2C%20no%20text&width=760&height=520&seq=buzz-02&orientation=landscape",
    tag: "综艺官宣",
    title: "新一季阵容公布引两极反应，粉丝盘点节目高光",
    excerpt: "从路透到官宣吊足胃口，有人期待满满，也有人怀念初代阵容。这场关于'变与不变'的讨论仍在继续。",
    comments: "9.4万",
    likes: "7.2万",
    time: "1 小时前",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Elegant%20editorial%203D%20illustration%20of%20a%20large%20magnifying%20glass%20over%20folded%20documents%20and%20coins%20in%20gold%20and%20melon%20green%20tones%20on%20warm%20cream%20paper%20background%2C%20financial%20investigation%20theme%2C%20soft%20lighting%2C%20refined%20modern%20art%2C%20no%20text&width=760&height=520&seq=buzz-03&orientation=landscape",
    tag: "消费真相",
    title: "大促套路被逐一拆解，理性消费攻略受追捧",
    excerpt: "满减、返券、预售……面对越来越复杂的玩法，越来越多网友选择先算账再下单，攻略帖点赞数十万。",
    comments: "7.6万",
    likes: "8.9万",
    time: "2 小时前",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20editorial%203D%20illustration%20of%20a%20vintage%20food%20cart%20with%20steaming%20bowls%20at%20night%2C%20glowing%20warm%20amber%20lights%2C%20watermelon%20red%20and%20cream%20palette%2C%20cozy%20street%20food%20storytelling%20scene%2C%20soft%20bokeh%2C%20no%20people%20faces%2C%20no%20text&width=760&height=520&seq=buzz-04&orientation=landscape",
    tag: "治愈百态",
    title: "深夜美食摊主走红：一句'慢慢吃'治愈无数人",
    excerpt: "不靠夸张剧情，只是踏踏实实做饭、热络招呼顾客，这份朴素却让评论区成了打工人的深夜树洞。",
    comments: "8.1万",
    likes: "10.3万",
    time: "2 小时前",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dynamic%20isometric%203D%20illustration%20of%20a%20golden%20trophy%20and%20running%20track%20with%20confetti%20in%20melon%20green%20and%20gold%20on%20warm%20cream%20background%2C%20sports%20victory%20celebration%2C%20soft%20studio%20lighting%2C%20modern%20editorial%20art%2C%20no%20text&width=760&height=520&seq=buzz-05&orientation=landscape",
    tag: "体坛名场面",
    title: "决胜局惊天逆转，黑马新秀一战成名引热议",
    excerpt: "赛前不被看好的小将，用一场逆风翻盘改写剧本。赛后采访那句'我只是没想放弃'直接冲上热搜。",
    comments: "6.9万",
    likes: "11.7万",
    time: "3 小时前",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Playful%20editorial%203D%20illustration%20of%20a%20giant%20smartphone%20with%20glowing%20notification%20icons%20and%20popcorn%20bucket%20floating%20in%20watermelon%20red%20and%20cream%20scene%2C%20hot%20topic%20viral%20concept%2C%20soft%20gradient%20background%2C%20modern%20magazine%20art%2C%20no%20text&width=760&height=520&seq=buzz-06&orientation=landscape",
    tag: "网络现象",
    title: "反套路短剧为何越看越上头，爆款公式被拆解",
    excerpt: "节奏快、反转密、情绪拉满，微短剧热度持续走高。行业观察者认为，内容创新才是长红的关键。",
    comments: "5.7万",
    likes: "6.8万",
    time: "4 小时前",
  },
];

export interface DeepItem {
  img: string;
  tag: string;
  title: string;
  readTime: string;
  date: string;
  lead: string;
  body: string;
}

export const deepList: DeepItem[] = [
  {
    img: "https://readdy.ai/api/search-image?query=Wide%20editorial%203D%20illustration%20of%20a%20cinema%20curtain%20and%20popcorn%20with%20floating%20film%20clapperboard%20in%20watermelon%20red%20coral%20and%20deep%20green%20on%20cream%2C%20movie%20review%20feature%20theme%2C%20soft%20studio%20lighting%2C%20refined%20magazine%20layout%20art%2C%20no%20text&width=1200&height=600&seq=deep-01&orientation=landscape",
    tag: "深度 · 影视",
    title: "评分与票房为何'打架'：一场关于好电影的共识讨论",
    readTime: "8 分钟",
    date: "2026-09-05",
    lead: "当一部影片的口碑持续走高、票房却表现平淡时，究竟是观众用脚投票，还是宣发节奏出了问题？",
    body: "我们把这一周关于暑期档的讨论梳理了一遍，从专业影评人的长文、普通观众的短评到宣发团队的复盘，试图还原一场口碑与市场之间的拉锯。有人认为流量与品质本就不该对立，也有人坚持'好故事永远有观众'。当讨论逐渐从情绪走向方法论，或许我们更接近一个共识：让作品回归作品，让评价回归内容。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Modern%20isometric%203D%20illustration%20of%20a%20stage%20with%20spotlight%20and%20glowing%20camera%20lens%20in%20melon%20green%20teal%20and%20gold%20on%20warm%20cream%2C%20variety%20show%20and%20talent%20industry%20theme%2C%20soft%20studio%20lighting%2C%20editorial%20art%2C%20no%20text&width=1200&height=600&seq=deep-02&orientation=landscape",
    tag: "深度 · 综艺",
    title: "综艺换代进行时：情怀回归与新鲜血液如何两全",
    readTime: "7 分钟",
    date: "2026-09-04",
    lead: "一档老牌综艺的阵容变动，为何能同时撬动老粉的怀旧与对新人的期待？",
    body: "从官宣前的路透到公布后的两极反馈，我们记录了这场关于'变与不变'的公共讨论。一边是初代阵容的集体回忆，一边是对新面孔的满满好奇。制作团队在采访中坦言，创新从来不是推翻重来，而是让老观众安心、新观众惊喜。当一代人把自己追过的节目讲给下一代人听，综艺的意义早已超越了娱乐本身。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20editorial%203D%20illustration%20of%20glowing%20chat%20bubbles%20and%20a%20sunrise%20over%20city%20skyline%20in%20watermelon%20red%20and%20cream%20on%20soft%20melon%20background%2C%20online%20community%20and%20kindness%20theme%2C%20soft%20lighting%2C%20modern%20art%2C%20no%20text&width=1200&height=600&seq=deep-03&orientation=landscape",
    tag: "深度 · 现象",
    title: "当一个陌生人的善意刷屏：互联网还能这么暖",
    readTime: "6 分钟",
    date: "2026-09-03",
    lead: "几天前的一条随手记录，让几十万人在评论区留下了自己的故事。",
    body: "我们回溯了这条刷屏帖的传播路径：从普通发布到小范围转发，再到被大号引用后的爆发。真正打动人的不是流量本身，而是评论区里那些素不相识的人，愿意停下来讲出自己的经历。有研究者指出，算法追逐情绪，但能长期留下用户的，往往是真诚的连接。在这场热闹散去之后，我们更想聊一聊：如何让善意被看见，也让它持续下去。",
  },
];

export interface StatItem {
  value: string;
  label: string;
  icon: string;
}

export const stats: StatItem[] = [
  { value: "1280万+", label: "月均热度阅读", icon: "ri-eye-line" },
  { value: "3.6万条", label: "累计热议话题", icon: "ri-discuss-line" },
  { value: "482 个", label: "深度盘点专题", icon: "ri-file-list-3-line" },
  { value: "98%", label: "热度指数更新率", icon: "ri-flashlight-line" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  { q: "吃瓜17 的热度排行是怎么来的？", a: "吃瓜17 会对全网公开信息进行热度聚合与分析，综合话题讨论量、阅读增长、时间衰减等因素动态计算热度指数，每 5 分钟自动刷新一次，让排行更贴近当下的讨论热度。" },
  { q: "这里的'大瓜盘点'内容真实吗？", a: "吃瓜17 只做公开信息的聚合与梳理，并明确标注信息来源与讨论走向。我们坚持不传谣、不造谣，涉及争议的内容会引导读者关注官方与当事人声明，理性看待。" },
  { q: "为什么某些话题的热度会快速起落？", a: "网络热度的波动很常见：突发事件往往短时间冲高，也会因新话题接力或官方回应而降温。吃瓜17 的排行会真实呈现这种起伏，不做人为的增删或掩盖。" },
  { q: "我也可以参与投稿或爆料吗？", a: "当然可以。你可以在页面底部的'投稿爆料'表单提交素材线索，内容通过审核后有机会被收录进话题盘点。投稿请确保提供真实、可查证的信息，并尊重他人隐私与权益。" },
  { q: "吃瓜17 与明星艺人有直接关系吗？", a: "吃瓜17 是独立的资讯聚合与讨论平台，与任何艺人、片方、节目或品牌均无隶属或利益关系，我们以中立视角呈现公开讨论，供大家理性参考。" },
];

export interface ReviewItem {
  quote: string;
  name: string;
  role: string;
}

export const reviewList: ReviewItem[] = [
  { quote: "刷榜单像在追一部连续剧，各种线索越挖越深，还能顺着专题看完整个前因后果，太省心了。", name: "晚风与少年", role: "活跃读者 · 3 年" },
  { quote: "最打动我的是它的'克制'，不渲染情绪、不乱带节奏，把讨论留给读者自己，这才是有温度的吃瓜。", name: "一只路过的猫", role: "话题贡献者" },
  { quote: "工作忙又想快速跟上热点，每天花十分钟扫一遍排行和深度盘点就够了，信息密度刚刚好。", name: "朝九晚五社畜", role: "老读者" },
];

export const principleList: string[] = [
  "不造谣不传谣，只聚合公开可查证的信息",
  "尊重隐私与人格，争议内容引导至官方渠道核实",
  "立场中立，把情绪留给读者，把事实还给事件",
  "热点实时刷新，信息不滞后、不隐瞒、不夸大",
];

export interface TimelineItem {
  year: string;
  text: string;
}

export const timeline: TimelineItem[] = [
  { year: "创办", text: "以'把热点讲清楚'为初心，从每日热度播报起步。" },
  { year: "成长", text: "上线热度排行与分类专区，开始系统梳理热议大瓜的来龙去脉。" },
  { year: "深耕", text: "推出深度盘点与专题讨论，推动理性围观、平和交流的氛围。" },
  { year: "现在", text: "专注做好热点聚合与内容梳理，陪伴大家看世界、读热搜。" },
];